import { create } from "zustand"
import { persist, createJSONStorage } from "zustand/middleware"

const C_CHAVE_BASE = "kanbanFilters"

const obterChaveFiltrosKanban = () => {
  try {
    const cEmpresaId = localStorage.getItem("companyId")
    const cUsuarioId = localStorage.getItem("userId")
    if (cEmpresaId && cUsuarioId) {
      return `${C_CHAVE_BASE}:${cEmpresaId}:${cUsuarioId}`
    }
  } catch (oErro) {
    // localStorage indisponível
  }
  return C_CHAVE_BASE
}

const sanitizarFilasFiltroKanban = (mFilas = []) =>
  (mFilas || []).filter((oFila) => oFila?.id !== 0 && oFila?.id !== "0")

const sanitizarFiltrosKanban = (oFiltros = {}) => ({
  queues: sanitizarFilasFiltroKanban(oFiltros.queues),
  situacoes: oFiltros.situacoes || [],
  users: oFiltros.users || [],
  empresa: oFiltros.empresa || "",
  motivo: (oFiltros.motivo || []).filter((oItem) => oItem?.id !== 0 && oItem?.id !== "0"),
  contatos: oFiltros.contatos || [],
  contatosSelecionados: oFiltros.contatosSelecionados || [],
  lidas: oFiltros.lidas !== undefined && oFiltros.lidas !== null ? oFiltros.lidas : true,
})

const oStorageEscopado = createJSONStorage(() => ({
  getItem: (_cNome) => {
    try {
      return localStorage.getItem(obterChaveFiltrosKanban())
    } catch (oErro) {
      return null
    }
  },
  setItem: (_cNome, cValor) => {
    try {
      localStorage.setItem(obterChaveFiltrosKanban(), cValor)
    } catch (oErro) {
      // ignore
    }
  },
  removeItem: (_cNome) => {
    try {
      localStorage.removeItem(obterChaveFiltrosKanban())
    } catch (oErro) {
      // ignore
    }
  },
}))

export const useKanbanFiltrosStore = create(
  persist(
    (set) => ({
      filters: {},

      aplicarFiltros: (oFiltros) => set({ filters: sanitizarFiltrosKanban(oFiltros) }),

      reiniciar: () => set({ filters: {} }),
    }),
    {
      name: C_CHAVE_BASE,
      storage: oStorageEscopado,
      partialize: (oState) => ({ filters: oState.filters }),
    },
  ),
)
